import { render, staticRenderFns } from "./MultiDeleteButton.vue?vue&type=template&id=e624b2d8"
import script from "./MultiDeleteButton.vue?vue&type=script&lang=js"
export * from "./MultiDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports